// ======================================================================
// File Name       : ContentBigQuestionAdvanced
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Form, FormControl, Col } from 'react-bootstrap';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';

class ContentBigQuestionAdvanced extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event) {
    const { name, value } = event.target;
    this.props.onInputChange(name, value);
  }
  onChangeCheckbox(event) {
    this.props.onCheckboxChange(event);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      limitTime,
      hintUse,
      hintContent,
      hintHtmlUse,
      hintZipFileName,
      explanationUse,
      explanationContent,
      explanationHtmlUse,
      explanationZipFileName,
      onInputChange,
      onCheckboxChange,
      handleHintHtmlFileChange,
      handleExplanationHtmlFileChange,
    } = this.props;
    const acceptFile = 'application/zip,application/x-zip,application/x-zip-compressed';
    this.refsToValidate = [];
    return (
      <div>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            制限時間
          </Col>
          <Col sm={7}>
            <FormControlValidate
              type="text"
              name="limitTime"
              value={limitTime}
              onChange={this.onChange}
              maxLength="4"
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              validateType={VALIDATE_TYPE.MAX_NUMBER}
              maxNumber="3600"
              label="制限時間"
            />
          </Col>
          <Col as={Form.Label}>秒</Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4} className="margin-top-10">
            解答解説を使用する
          </Col>
          <Col sm={2}>
            <Form.Check
              type="checkbox"
              className="margin-top-10"
              checked={explanationUse}
              name="explanationUse"
              id="explanationUse"
              onChange={this.onChangeCheckbox}
            />
          </Col>
          {explanationUse && (
            <Col sm={12} className="margin-top-10 padding-left-right-clear">
              <Col as={Form.Label} sm={2} className="padding-left-right-clear" />
              <Col as={Form.Label} sm={2} className="padding-left-right-clear">
                内容
              </Col>
              <Col sm={7}>
                <Col sm={6} className="padding-left-right-clear">
                  <Form.Check
                    type="radio"
                    inline
                    className="padding-top-clear"
                    name="explanationHtmlUse"
                    id="explanationHtmlUse-0"
                    value={0}
                    onChange={this.onChange}
                    disabled={!explanationUse}
                    checked={explanationHtmlUse === "0"}
                    label="HTMLを使用しない"
                  ></Form.Check>
                </Col>
                <Col sm={6}>
                  <Form.Check
                    type="radio"
                    inline
                    className="padding-top-clear"
                    name="explanationHtmlUse"
                    id="explanationHtmlUse-1"
                    value={1}
                    onChange={this.onChange}
                    disabled={!explanationUse}
                    checked={explanationHtmlUse === "1"}
                    label="HTMLを使用する"
                  ></Form.Check>
                </Col>
                {explanationHtmlUse === "0" && (
                  <Col
                    sm={12}
                    className="margin-bottom-10 margin-top-10 padding-left-right-clear"
                  >
                    <FormControlValidate
                      as="textarea"
                      className="textArea"
                      name="explanationContent"
                      disabled={!explanationUse}
                      onChange={this.onChange}
                      value={explanationContent}
                      maxLength="30000"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      required={explanationUse && explanationHtmlUse === "0"}
                      label="内容"
                    />
                  </Col>
                )}
                {explanationHtmlUse === "1" && (
                  <Col sm={12} className="margin-top-10 padding-left-clear">
                    <Col sm={12} className="padding-left-clear">
                      <FileUpload
                        labelName="ファイル選択"
                        fileName={explanationZipFileName}
                        onChange={handleExplanationHtmlFileChange}
                        disabled={!explanationUse}
                        accept={acceptFile}
                        inputId={"explanationZipFile"}
                      />
                    </Col>
                    <Col sm={12} className="margin-top-10 padding-left-clear">
                      <FormControlValidate
                        label="ファイル名"
                        validateType={VALIDATE_TYPE.LABEL}
                        value={
                          explanationZipFileName &&
                          `ファイル名：${explanationZipFileName}`
                        }
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        required
                      />
                    </Col>
                  </Col>
                )}
              </Col>
            </Col>
          )}
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={12} className="padding-left-clear">
            <Col as={Form.Label} sm={4} className="margin-top-10">
              ヒントを使用する
            </Col>
            <Col sm={2}>
              <Form.Check
                type="checkbox"
                className="margin-top-10"
                name="hintUse"
                id="hintUse"
                onChange={this.onChangeCheckbox}
                checked={hintUse}
              />
            </Col>
          </Col>
          {hintUse && (
            <Col sm={12} className="margin-top-10 padding-left-right-clear">
              <Col as={Form.Label}  sm={2} className="padding-left-right-clear" />
              <Col as={Form.Label} sm={2} className="padding-left-right-clear">
                内容
              </Col>
              <Col sm={7}>
                <Col sm={6} className="padding-left-right-clear">
                  <Form.Check
                    type="radio"
                    className="padding-top-clear"
                    inline
                    name="hintHtmlUse"
                    id="hintHtmlUse-0"
                    value={0}
                    onChange={this.onChange}
                    disabled={!hintUse}
                    checked={hintHtmlUse === "0"}
                    label="HTMLを使用しない"
                  ></Form.Check>
                </Col>
                <Col sm={6}>
                  <Form.Check
                    type="radio"
                    className="padding-top-clear"
                    inline
                    name="hintHtmlUse"
                    id="hintHtmlUse-1"
                    value={1}
                    onChange={this.onChange}
                    disabled={!hintUse}
                    checked={hintHtmlUse === "1"}
                    label="HTMLを使用する"
                  ></Form.Check>
                </Col>
                {hintHtmlUse === "0" && (
                  <Col
                    sm={12}
                    className="margin-bottom-10 margin-top-10 padding-left-right-clear"
                  >
                    <FormControlValidate
                      as="textarea"
                      className="textArea"
                      name="hintContent"
                      label="内容"
                      disabled={!hintUse}
                      onChange={this.onChange}
                      value={hintContent}
                      required={hintUse && hintHtmlUse === "0"}
                      maxLength="30000"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                    />
                  </Col>
                )}
                {hintHtmlUse === "1" && (
                  <Col sm={12} className="margin-top-10 padding-left-clear">
                    <Col sm={12} className="padding-left-clear">
                      <FileUpload
                        labelName="ファイル選択"
                        fileName={hintZipFileName}
                        onChange={handleHintHtmlFileChange}
                        disabled={!hintUse}
                        accept={acceptFile}
                        inputId={"hintZipFile"}
                      />
                    </Col>
                    <Col sm={12} className="margin-top-10 padding-left-clear">
                      <FormControlValidate
                        label="ファイル名"
                        validateType={VALIDATE_TYPE.LABEL}
                        value={
                          hintZipFileName && `ファイル名：${hintZipFileName}`
                        }
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        required
                      />
                    </Col>
                  </Col>
                )}
              </Col>
            </Col>
          )}
        </Form.Group>
      </div>
    );
  }
}

export default ContentBigQuestionAdvanced;
